import { v4 as uuidv4 } from 'uuid';

import { referencesFormSchema } from '@/components/modules/Application/components/References/_shared/schemas/referencesForm.schema';
import { ReferencesForms } from '@/components/modules/Application/components/References/ReferencesForms';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { developOptions } from '@/config/developOptions';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const References = () => {
  const {
    state: { orderReference1, orderReference2 },
  } = useApplicationContext();

  let defaultValues = {
    orderReference1: '',
  };

  if (developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES) {
    defaultValues = {
      ...defaultValues,
      orderReference1: uuidv4().split('-')[4],
    };
  }

  return (
    <FormWrapper
      formSchema={referencesFormSchema}
      defaultValues={{
        orderReference1: orderReference1 || defaultValues.orderReference1,
        orderReference2,
      }}
    >
      <ReferencesForms />
    </FormWrapper>
  );
};
